import { PageId } from 'constants/pages'

export const enum PageIdWoofzHlwn75 {
  SUBSCRIPTIONS_PAGE_HLWN_75 = PageId.SUBSCRIPTIONS_PAGE_HLWN_75,
  CHAT_UPSELL_HLWN_75 = PageId.CHAT_UPSELL_HLWN_75,
  UPSELL_HLWN_75 = PageId.UPSELL_HLWN_75,
  DOWNLOAD_HLWN_75 = PageId.DOWNLOAD_HLWN_75,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
